import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'pages.viewFulfilmentLocation.fulfilmentLocationPositions.title',
    defaultMessage: 'Positions',
    description: 'Title of the fulfilment location positions',
  },
  emptyMessage: {
    id: 'pages.viewFulfilmentLocation.fulfilmentLocationPositions.emptyMessage',
    defaultMessage: 'No positions found',
    description: 'Empty message of the positions list of the fulfilment location positions',
  },
  positionDialog: {
    title: {
      id: 'pages.viewFulfilmentLocation.fulfilmentLocationPositions.positionDialog.title',
      defaultMessage: 'Products',
      description: 'Title of the location position dialog of the fulfilment location positions',
    },
  },
  addMultiplePositionsDrawer: {
    title: {
      id:
        'pages.viewFulfilmentLocation.fulfilmentLocationPositions.addMultiplePositionsDrawer.title',
      defaultMessage: 'Add multiple positions',
      description: 'Title of the add multiple positions drawer',
    },
    columns: {
      position: {
        id: 'properties.position',
        defaultMessage: 'Position',
        description: 'Title of the position column of the add multiple positions drawer',
      },
    },
  },
  bulkActions: {
    deletePositions: {
      id: 'actions.delete',
      defaultMessage: 'Delete',
      description: 'Error message for the delete positions bulk action',
    },
  },
  feedback: {
    positionsAdded: {
      id: 'pages.viewFulfilmentLocation.fulfilmentLocationPositions.feedback.positionsAdded',
      defaultMessage: 'Positions added',
      description: 'Success message for the positions added action',
    },
    positionsNotAdded: {
      id: 'pages.viewFulfilmentLocation.fulfilmentLocationPositions.feedback.positionsNotAdded',
      defaultMessage: 'Positions could not be added',
      description: 'Error message for the positions added action',
    },
    positionsDeleted: {
      id: 'pages.viewFulfilmentLocation.fulfilmentLocationPositions.feedback.positionsDeleted',
      defaultMessage: 'Positions deleted',
      description: 'Success message for the positions deleted action',
    },
    positionsNotDeleted: {
      id: 'pages.viewFulfilmentLocation.fulfilmentLocationPositions.feedback.positionsNotDeleted',
      defaultMessage: 'Positions could not be deleted',
      description: 'Error message for the positions deleted action',
    },
  },
  exportPositions: {
    title: {
      id: 'pages.viewFulfilmentLocation.fulfilmentLocationPositions.exportPositions.title',
      defaultMessage: 'Export positions',
      description: 'Title of the export positions batch dialog',
    },
    reference: {
      id: 'pages.viewFulfilmentLocation.fulfilmentLocationPositions.exportPositions.reference',
      defaultMessage: 'Positions export {group} {value}',
      description: 'Default reference of the export positions batch dialog',
    },
    batchCreateLabel: {
      id:
        'pages.viewFulfilmentLocation.fulfilmentLocationPositions.exportPositions.batchCreateLabel',
      defaultMessage: 'Prepare positions',
      description: 'Default reference of the export positions batch dialog',
    },
    batchFailedLabel: {
      id:
        'pages.viewFulfilmentLocation.fulfilmentLocationPositions.exportPositions.batchFailedLabel',
      defaultMessage: 'Positions export failed',
      description: 'Batch failed label of the export positions batch dialog',
    },
    batchStartLabel: {
      id:
        'pages.viewFulfilmentLocation.fulfilmentLocationPositions.exportPositions.batchStartLabel',
      defaultMessage: 'Positions export',
      description: 'Batch start label of the export positions batch dialog',
    },
    batchValidationLabel: {
      id:
        'pages.viewFulfilmentLocation.fulfilmentLocationPositions.exportPositions.batchValidationLabel',
      defaultMessage: 'Validate positions and settings',
      description: 'Batch validation label of the export positions batch dialog',
    },
  },
};

export default defineMessages(translations);
